export const getLeadPartnerDashboard = (partner) => {
  const partnerRoles = partner?.leadPartnerOrg?.partnerRoles || [];
  const role = partnerRoles.find(
    (role) => role._id === partner?.leadPartnerRole
  );

  return role?.dashboards || [];
};
